import { render, staticRenderFns } from "./home-footer.vue?vue&type=template&id=587fb6b4&scoped=true"
import script from "./home-footer.vue?vue&type=script&lang=js"
export * from "./home-footer.vue?vue&type=script&lang=js"
import style0 from "./home-footer.vue?vue&type=style&index=0&id=587fb6b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587fb6b4",
  null
  
)

export default component.exports